module.exports = __webpack_public_path__ + "static/media/ch.3f0a5df9.svg";